import { useMemo, useState } from 'react';
import { EmptyString } from 'utils/Constant';
import bg1 from 'assets/images/login_bg/bg_1.jpg';
import bg2 from 'assets/images/login_bg/bg_2.jpg';
import bg3 from 'assets/images/login_bg/bg_3.jpg';
import bg4 from 'assets/images/login_bg/bg_4.jpg';
import bg5 from 'assets/images/login_bg/bg_5.jpg';
import bg6 from 'assets/images/login_bg/bg_6.jpg';
import bg7 from 'assets/images/login_bg/bg_7.jpg';
import bg8 from 'assets/images/login_bg/bg_8.jpg';
import bg9 from 'assets/images/login_bg/bg_9.jpg';
import bg10 from 'assets/images/login_bg/bg_10.jpg';
import { useAuth } from 'utils/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { AuthService } from 'services/AuthService/AuthService';
import { useModal } from 'utils/context/ModalContext';
import { useVariable } from 'utils/context/VariableContext';

const imageList = [bg1, bg2, bg3, bg4, bg5, bg6, bg7, bg8, bg9, bg10];

export default function Login() {
	const { login } = useAuth()
	const { 
		setVariableLocationOptions, 
		setVariableEdcOptions, 
		setVariableTransferSourceOptions, 
		setVariableUserId, 
		setVariableUsername, 
		setVariableName, 
		setVariableIsAdmin,
		setVariableLocationId 
	} = useVariable()
	const navigate = useNavigate()
	const { fetchLogin } = AuthService()
    const { showLoading, hideLoading } = useModal()

	const [username, setUsername] = useState(EmptyString)
	const [password, setPassword] = useState(EmptyString)
	const [loginMessage, setLoginMessage] = useState()
	const [isShowPassword, setIsShowPassword] = useState(false)

	const randomImage = useMemo(() => {
		const index = Math.floor(Math.random() * imageList.length)
		return imageList[index]
	}, []);

	const authLogin = async () => {
		const res = await fetchLogin(username, password)
		if (!res) return

		if(res.message !== EmptyString){
			setLoginMessage(res.message)
		}

		const data = res.data
		if (Object.keys(data).length === 0) return

		setVariableUserId(data.userId)
		setVariableUsername(data.username)
		setVariableName(data.fullName)
		setVariableIsAdmin(data.isAdmin)

		if (data.userLocations !== null && data.userLocations.length > 0) {
			let locationOptions = data.userLocations.map((item) => {
				return { value: String(item.locationId), label: item.locationName.toUpperCase() }
			})
			setVariableLocationOptions(locationOptions)
			setVariableLocationId(locationOptions[0].value)
		}

		if (data.transferSources !== null && data.transferSources.length > 0) {
			let transferSourceOptions = data.transferSources.map((item) => {
				return { value: String(item.transferSourceId), label: item.sourceName.toUpperCase() + " (" + item.accountNo + ")" }
			})
			setVariableTransferSourceOptions(transferSourceOptions)
		}

		if (data.edcList !== null && data.edcList.length > 0) {
			let edcOptions = data.edcList.map((item) => {
				return { 
					value: String(item.edcId), 
					label: item.bankCode + " - " + item.edcName.toUpperCase(),
					mdrOff: item.mdrOff,
                    mdrOn: item.mdrOn,
                    mdrCreditAmex: item.mdrCreditAmex,
                    mdrDebitOnUs: item.mdrDebitOnUs,
                    mdrDebitOffUs: item.mdrDebitOffUs,
                    mdrQrisOn: item.mdrQrisOn,
                    mdrQrisOff: item.mdrQrisOff,
                    type: item.type
				}
			})
			setVariableEdcOptions(edcOptions)
		}

		login(data.token)

		navigate("/")
	}

	function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			loginBtnClick()
		}
	}

	const loginBtnClick = async () =>{
		showLoading()

		// Perform validation
		if(!validation()){
			hideLoading()
			return
		}
		
		// Perform login
		await authLogin()
		hideLoading()
	}

	const validation = () => {
		let isValid = true
	
		if (username === EmptyString) {
			isValid = false
			setLoginMessage("Please enter username")
		} else if (password === EmptyString) {
			isValid = false
			setLoginMessage("Please enter password")
		} else {
			setLoginMessage(EmptyString)
		}

		return isValid
	}

	return (
		<div className="w-full h-screen fixed overflow-hidden flex flex-col justify-center items-center gap-8 bg-cover bg-center"
			style={{ backgroundImage: `url(${randomImage})` }}
		>
			<div className='shadow-md rounded-lg py-16 px-6 sm:px-12 bg-white/60 backdrop-blur-sm'>
				<div className='flex flex-col gap-4 items-center'>
					<span className='text-3xl md:text-5xl font-semibold'>Yupiter</span>
					<span className='text-2xl'>Login</span>
				</div>

				<div className='flex flex-col bg-blue w-80 gap-4 mt-8'>
					<div>
						<input 
							className='seq-input focus:outline-none focus:ring-0 focus:border-transparent border border-gray-300 !rounded-full'
							value={username} 
							onChange={(e) => {setUsername(e.target.value)}} onKeyDown={(e) => { fEnterKeyDown(e) }} 
							placeholder='Username'
						/>
					</div>
					
					<div>
						<input 
							className='seq-input focus:outline-none focus:ring-0 focus:border-transparent border border-gray-300 !rounded-full' 
							value={password} 
							onChange={(e) => {setPassword(e.target.value)}} onKeyDown={(e) => { fEnterKeyDown(e) }} 
							type={isShowPassword ? 'text' : 'password'} 
							placeholder='Password'
						/>
					</div>

					<div className='flex items-center gap-2'>
						<input className='w-4' value={isShowPassword} checked={isShowPassword} onChange={() => { setIsShowPassword(!isShowPassword) }} type='checkbox' />
						<span>Show password</span>
					</div>

					<div>
						<span className='text-red-500'>{loginMessage}</span>
					</div>

					<button className={`login-button bg-black mt-4 !rounded-full`} onClick={() => loginBtnClick()} >
						Login
					</button>
				</div>
			</div>
		</div>
	)
}
